module.exports = __webpack_public_path__ + "img/logo.f3c3eb61.svg";